import JsPDF from "jspdf";
import "jspdf-autotable";
import logoSquare from "./../../images/logos/logo-sq.png";

class CorporateInvoiceExport {
  constructor($injector, Events) {
    "ngInject";
    this.Events = Events;
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
    this.CorporateInvoiceTransforms = $injector.get(
      "CorporateInvoiceTransforms"
    );
  }
  $onInit() {}

  exportInvoice(invoice) {
    try {
      const doc = new JsPDF("p", "mm", "a4");

      // Header
      const logoSize = 25;
      const logoImg = new Image();
      logoImg.src = logoSquare;
      doc.addImage(logoImg, "png", 10, 10, logoSize, logoSize);
      doc.setTextColor("#ef5547");
      doc.setFontType("bold");
      doc.setFontSize(30);
      doc.text(logoSize + 15, logoSize, "Corporate Invoice");

      // Info
      doc.autoTable({
        body: this.CorporateInvoiceTransforms.infoTableBody,
        bodyStyles: { fontSize: 12 },
        startY: logoSize + 18,
        theme: "plain",
        tableWidth: 150,
        margin: { left: 10 },
      });

      // Summary Table
      doc.setFontSize(16);
      doc.setTextColor("#000");
      doc.text(10, 75, "Invoice Summary");
      doc.autoTable({
        head: [["Description", "Count", "Amount"]],
        body: this.CorporateInvoiceTransforms.summaryTableBody,
        foot: this.CorporateInvoiceTransforms.summaryTableFooter,
        startY: 80,
        theme: "plain",
        headStyles: { fillColor: "#f8cbcb", fontStyle: "bold" },
        footStyles: { lineWidth: 0.2, lineColor: "#000", fontStyle: "normal" },
        tableWidth: 150,
        margin: { left: 10 },
      });
      const summaryTableY = doc.previousAutoTable.finalY;

      // Details Table
      doc.setFontType("bold");
      doc.text(10, summaryTableY + 15, "Invoice Details");

      doc.autoTable({
        head: [["Date", "Time", "Bus Type", "Route", "Description", "Amount"]],
        body: this.CorporateInvoiceTransforms.detailsTableBody,
        foot: this.CorporateInvoiceTransforms.detailsTableFooter,
        startY: summaryTableY + 20,
        theme: "plain",
        headStyles: { fillColor: "#f8cbcb", fontStyle: "bold" },
        footStyles: { lineWidth: 0.2, lineColor: "#000", fontStyle: "normal" },
        showFoot: "lastPage",
        tableWidth: 190,
        margin: { left: 10 },
      });

      const detailsTableY = doc.previousAutoTable.finalY;

      // Amount in words and thanks text
      doc.autoTable({
        body: this.CorporateInvoiceTransforms.amountTableBody,
        bodyStyles: { fontSize: 12 },
        startY: detailsTableY + 15,
        theme: "plain",
        tableWidth: 190,
        margin: { left: 10 },
      });

      const amountTableY = doc.previousAutoTable.finalY;

      doc.setFontSize(16);
      doc.setFontType("bold");
      doc.text(60, amountTableY + 15, "Thank you for choosing SWVL!");

      const { corporate, start_date: startDate, end_date: endDate } = invoice;
      doc.save(`${corporate.name}_${startDate}_${endDate}.pdf`);
    } catch (err) {
      this.Events.emit(this.errorNotificationEvent, {
        message: "Error exporting invoice",
      });
    }
  }
}

export default CorporateInvoiceExport;



// WEBPACK FOOTER //
// ./src/services/corporateInvoiceExport/corporateInvoiceExport.service.js